import EditorPropsContext from '@Editor/EditorPropsContext';
import { useContext } from 'react';

const useEditorProps = () => useContext(EditorPropsContext);

export default useEditorProps;
